import $ajax from 'axios'
// import {Message} from 'element-ui'
import api from '@/utils/api'
import { hideLoad } from '@/tools/loading.js' // 引入封装的loading方法
import msgWarning from '@/tools/msgwarning.js'

/*
  门店属性
  CourierMaps: null       // 专送门店绑定
  StoreMaps: Array(1)     // 平台门店绑定
  address: "广东省广州市番禺区南村镇里仁洞村环城东路1号之—广州市番禺区仁发综合市场135.36号"
  cityCode: 440100
  cityName: "广州市"
  closeTime1: 1830
  closeTime2: 0
  createdAt: "2018-10-28T13:56:52+08:00"
  deletedAt: "1970-01-01T00:00:00+08:00"
  deliveryRange: "1"      // 1平台专送 0平台众包配送 2门店自送
  deliveryRangeType: 3    // 3圆 2多边形
  districtCode: 440113
  districtName: "番禺区"
  id: 101196              // 京西门店编号
  idCardBack: ""          // 身份证背面url
  idCardFront: ""         // 身份证正面url
  idCardHand: ""          // 手持身份证url
  licence: ""             // 营业执照url
  licenceCode: ""         // 营业执照编号 18位
  lastOperator: "builder"
  lat: 22.98976
  lng: 113.34823
  name: "仁发店"           // 店名
  openTime1: 800
  openTime2: 0
  status: -1             状态
  tel1: "18573407502"    店长电话
  tel2: "13118850260"
  updatedAt: "2018-10-28T13:56:52+08:00"
*/


/* 11732425
  获取京西门店信息 get /store/GetStores
  keyword        str 查询关键字（可以为空）
  storeID             int 门店ID（京西）
  name           str 门店名称（支持模糊）
  placeID        int 所属地点ID 全国 100000
  placeLevel     int 所属地点级别 省为1，市为2，区为3
  address        str 门店地址
  tel            str 电话
  statuss        arr [-1, 0, 1]
  -fromStatus     int 起始状态 -1禁用 0休息，关店 1正常开店
  -toStatus       int 结束状态
  offset         int 序号(配合翻页)
  pageSize       int 默认50

  vendorStoreCond str and 与 or 或
  jdCond int -1未关联 0不限定 1已关联   默认0
  elemCond
  ebaiCond
*/

export const getStores = async (json = {}) => {
  let params = {}
  if (json.keyword) params.keyword = json.keyword
  if (json.storeID) params.storeID = json.storeID
  if (json.storeIDs && json.storeIDs.length > 0) params.storeIDs = JSON.stringify(json.storeIDs)
  if (json.placeID) params.placeID = json.placeID
  if (json.statuss && json.statuss.length > 0) params.statuss = JSON.stringify(json.statuss)
  params.vendorStoreCond = 'or'
  if (json.vendorStoreConds) params.vendorStoreConds = JSON.stringify(json.vendorStoreConds)
  if (json.hasOwnProperty('offset')) params.offset = json.offset
  if (json.pageSize) params.pageSize = json.pageSize
  if (json.briefLevel) params.briefLevel = json.briefLevel
  if (json.statuss) params.statuss = json.statuss
  try {
    let res = await api('v2/store/GetStores', {
      params,
      noLoading: !!json.noLoading
    })
    return res
  } catch (e) {
    msgWarning(e)
    return []
  } finally {
    if (!json.noLoading) hideLoad()
  }
}


/*
  得到门店映射信息 get /store/GetStoreVendorMaps
  storeID int 京西门店ID
  vendorID int 缺省全部
*/

/*
  远程查询厂商门店信息 get /store/GetVendorStore
  vendorStoreID str 门店ID
  vendorID      int 所属厂商 0京东 1美团 11微盟微商城
*/
function GetVendorStore(vendorStoreID, vendorID, vendorOrgCode) {
  return new Promise((resolve, reject) => {
    $ajax.get('v2/store/GetVendorStore', {
      params: {
        vendorStoreID, vendorID, vendorOrgCode
      }
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

/*
  得到门店映射信息 get /store/GetStoreVendorMaps
  storeID int 京西门店ID
  vendorID int 厂商ID 默认全部
*/

/*
  修改门店信息 put formdata /store/UpdateStore
  storeID int 京西门店编号
  payload str json数据store对象 对象中传id和需要修改的
*/
async function updateStore(storeID, json, fn) {
  try {
    let res = await api('v2/store/UpdateStore', {
      method: 'PUT',
      data: `storeID=${storeID}&payload=${encodeURIComponent(JSON.stringify(json))}`
    })
    if (res.code && res.code === '-105') {
      fn && fn(res)
    } else {
      fn && fn({ code: '0' })
    }
  } catch (e) {
    fn && fn(e)
  }
}

/*
  创建门店 /store/CreateStore post
  payload
  11732425
*/
function createStore(json, fn) {
  // 处理id
  json.id = Number(json.id)
  let formData = new FormData()
  formData.append('payload', JSON.stringify(json))
  $ajax.post('v2/store/CreateStore', formData, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(res => {
    hideLoad()
    if (res.data.code === '0') {
      fn && fn(res.data)
    } else {
      msgWarning(res.data.desc)
    }
  }).catch(err => {
    hideLoad()
  })
}

/*
  获取所有平台门店映射 get /store/GetStoreVendorMaps
  storeID   int 门店ID
  vendorID  int 厂商ID 缺省为全部
*/
function getStoreVendorMaps(storeID, fn) {
  $ajax.get('v2/store/GetStoreVendorMaps', {
    params: {
      storeID
    }
  }).then(res => {
    hideLoad()
    if (res.data.code === '0') {
      fn && fn(res.data)
    } else {
      msgWarning(res.data.desc)
    }
  }).catch(err => {
    hideLoad()
  })
}
function getStoreVendorMap(storeID, vendorID, fn) {
  $ajax.get('v2/store/GetStoreVendorMaps', {
    params: {
      storeID, vendorID
    }
  }).then(res => {
    hideLoad()
    if (res.data.code === '0') {
      fn && fn(res.data)
    } else {
      msgWarning(res.data.desc)
    }
  }).catch(err => {
    hideLoad()
  })
}
/*
  新增门店映射 post /store/AddStoreVendorMap
  storeID int
  vendorID int
  payload json ({’vendorID’:0,’vendorStoreID’:’11732425’,’autoPickup’:1,’deliveryCompetition’:1, 'pricePercentage’:100})
  isSync 0不同步   1同步
*/
async function addStoreVendorMap(storeID, vendorID, json, fn) {
  try {
    json.autoPickup = Number(json.autoPickup)
    json.deliveryCompetition = Number(json.deliveryCompetition)
    json.pricePercentage = Number(json.pricePercentage)
    // if (json.deliveryType) json.deliveryType = Number(json.deliveryType)
    let data = `storeID=${storeID}&vendorID=${vendorID}&payload=${encodeURIComponent(JSON.stringify(json))}`
    if (json.vendorOrgCode) data += `&vendorOrgCode=${json.vendorOrgCode}`
    delete json.deliveryType
    let res = await api('v2/store/AddStoreVendorMap', {
      method: 'POST',
      data
    })
    if (res && res.code && res.code === '-105') {
      fn && fn(res)
    } else if (res.code == '0' || res.code == '-1') {
      fn && fn({ code: '0' })
    }
  } catch (e) {
    fn && fn(e)
  }
}

/*
  删除门店映射 delete /store/DeleteStoreVendorMap
  storeID   int 门店ID
  vendorID  int 厂商ID
*/

async function deleteStoreVendorMap(storeID, vendorID, fn) {
  try {
    let res = await api('v2/store/DeleteStoreVendorMap', {
      method: 'DELETE',
      params: {
        storeID, vendorID
      }
    })
    if (res.code && res.code === '-105') {
      fn && fn(res)
    } else {
      fn && fn({ code: '0' })
    }
  } catch (e) {
    fn && fn(e)
  }
}

/* 11732425
  修改门店映射信息 put /store/UpdateStoreVendorMap
  storeID   int 门店ID
  vendorID  int 厂商ID
  payload
*/
async function updateStoreVendorMap(storeID, vendorID, json, fn) {
  try {
    if (json.autoPickup) json.autoPickup = Number(json.autoPickup)
    if (json.deliveryCompetition) json.deliveryCompetition = Number(json.deliveryCompetition)
    if (json.pricePercentage) json.pricePercentage = Number(json.pricePercentage)
    // if (json.deliveryType) json.deliveryType = Number(json.deliveryType)
    delete json.deliveryType
    let data = `storeID=${storeID}&vendorID=${vendorID}&payload=${encodeURIComponent(JSON.stringify(json))}`
    if (json.vendorOrgCode) data += `&vendorOrgCode=${json.vendorOrgCode}`
    let res = await api('v2/store/UpdateStoreVendorMap', {
      method: 'PUT',
      data
    })
    if (res.code && res.code === '-105') {
      fn && fn(res)
    } else {
      fn && fn({ code: '0' })
    }
  } catch (e) {
    fn && fn(e)
  }
}

/*
  导出美团订单 get /order/ExportMTWaybills
  fromDate str
  toDate   str
*/
function exportMTOrder(fromDate, toDate, fn) {
  $ajax.get('v2/order/ExportMTWaybills', {
    params: {
      fromDate,
      toDate
    }
  }).then(res => {
    hideLoad()
    if (res.data.code === '0') {
      fn && fn(res.data)
    } else {
      msgWarning(res.data.desc)
    }
  }).catch(err => {
    hideLoad()
  })
}

/*
  得到平台门店快递映射 get /store/GetStoreCourierMaps
  storeID     int 门店ID
  vendorID    int 厂商ID 102 103
*/
function getStoreCourierMaps(storeID, vendorID, fn) {
  $ajax.get('v2/store/GetStoreCourierMaps', {
    params: {
      storeID, vendorID
    }
  }).then(res => {
    hideLoad()
    if (res.data.code === '0') {
      fn && fn(JSON.parse(res.data.data))
    } else {
      msgWarning(res.data.desc)
    }
  }).catch(err => {
    hideLoad()
  })
}
/*
  添加门店快递映射 post
/store/AddStoreCourierMap
  storeID     int 门店ID
  vendorID    int 101 102
  payload {
    status, vendorStoreId
  }
*/
function addStoreCourierMap(storeID, vendorID, json, fn) {
  // 处理数据格式
  let formData = new FormData()
  formData.append('storeID', storeID)
  formData.append('vendorID', vendorID)
  formData.append('payload', JSON.stringify(json))
  $ajax.post('v2/store/AddStoreCourierMap', formData, {
    // headers: {
    //   'Content-Type': 'application/x-www-form-urlencoded'
    // }
  }).then(res => {
    hideLoad()
    if (res.data.code === '0') {
      fn && fn(res.data)
    } else {
      msgWarning(res.data.desc)
    }
  }).catch(err => {
    hideLoad()
  })
}

/*
  修改门店快递映射 put /store/UpdateStoreCourierMap
  storeID     int 门店ID
  vendorID    int 101 102
  payload {
    status, vendorStoreId
  }
*/
function updateStoreCourierMap(storeID, vendorID, json, fn) {
  let formData = new FormData()
  formData.append('storeID', storeID)
  formData.append('vendorID', vendorID)
  formData.append('payload', JSON.stringify(json))
  $ajax.put('v2/store/UpdateStoreCourierMap', formData, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(res => {
    hideLoad()
    if (res.data.code === '0') {
      fn && fn(res.data)
    } else {
      msgWarning(res.data.desc)
    }
  }).catch(err => {
    hideLoad()
  })
}

/*
  删除门店快递映射 delete
/store/DeleteStoreCourierMap
  storeID     int 门店ID
  vendorID    int 101 102
*/
function deleteStoreCourierMap(storeID, vendorID, fn) {
  $ajax.delete('v2/store/DeleteStoreCourierMap', {
    params: {
      storeID, vendorID
    }
  }).then(res => {
    hideLoad()
    if (res.data.code === '0') {
      fn && fn(res.data)
    } else {
      msgWarning(res.data.desc)
    }
  }).catch(err => {
    hideLoad()
  })
}
// 平台门店上下线
function updateVendorStoreStatus(storeID, vendorIDs, status, fn) {
  // 处理数据格式
  let formData = new FormData()
  formData.append('storeID', storeID)
  formData.append('vendorIDs', vendorIDs)
  formData.append('status', status)
  $ajax.post('v2/store/UpdateVendorStoreBussinessStatus', formData, {
    // headers: {
    //   'Content-Type': 'application/x-www-form-urlencoded'
    // }
  }).then(res => {
    hideLoad()
    if (res.data.code === '0') {
      fn && fn(res.data)
    } else {
      msgWarning(res.data.desc)
    }
  }).catch(err => {
    hideLoad()
  })
}
/*
  删除京西门店 delete
/store/DeleteStore
  storeID     int 门店ID
  vendorID    int 101 102
*/
function deleteStoreApi(storeID, fn) {
  $ajax.delete('v2/store/DeleteStore', {
    params: {
      storeID: storeID
    }
  }).then(res => {
    hideLoad()
    fn && fn(res.data)
  }).catch(res => {
    msgWarning(res.data.desc)
    hideLoad()
  })
}

/*
  补全转送门店达达 put /store/RefreshMissingDadaStores
  storeID
  isAsync
  isContinueWhenError
*/
export const refreshDD = (json, fn) => {
  let formData = new FormData()
  formData.append('isAsync', json.isAsync)
  formData.append('isContinueWhenError', json.isContinueWhenError)
  $ajax.put('v2/store/RefreshMissingDadaStores', formData, {
    timeout: 1000 * 300,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(res => {
    hideLoad()
    if (res.data.code === '0') {
      fn && fn(res.data)
    } else {
      msgWarning(res.data.desc)
    }
  }).catch(err => {
    hideLoad()
  })
}
// 启用所有临时休息的门店
export const enableRestStore = (json, fn) => {
  let formData = new FormData()
  formData.append('isAsync', json.isAsync)
  formData.append('isContinueWhenError', json.isContinueWhenError)
  $ajax.put('v2/store/EnableHaveRestStores', formData, {
    timeout: 1000 * 300,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then(res => {
    hideLoad()
    if (res.data.code === '0') {
      fn && fn(res.data)
    } else {
      msgWarning(res.data.desc)
    }
  }).catch(err => {
    hideLoad()
  })
}
// 饿百创建平台门店
const createVendorStore = (storeID, vendorID, json, fn) => {
  let formData = new FormData()
  formData.append('storeID', storeID)
  formData.append('vendorID', vendorID)
  formData.append('payload', JSON.stringify(json))
  $ajax.post('v2/store/CreateVendorStore', formData, {
  }).then(res => {
    hideLoad()
    if (res.data.code === '0') {
      fn && fn(res.data)
    } else {
      msgWarning(res.data.desc)
    }
  }).catch(err => {
    hideLoad()
  })
}
// 同步门店资质
const syncStoresQualify = (json, fn) => {
  let formData = new FormData()
  formData.append('storeIDs', json.storeIDs)
  formData.append('vendorID', json.vendorID)
  formData.append('isAsync', json.isAsync)
  formData.append('isContinueWhenError', json.isContinueWhenError)
  $ajax.post('v2/store/SyncStoresQualify', formData, {
  }).then(res => {
    hideLoad()
    if (res.data.code === '0') {
      fn && fn(res.data)
    } else {
      msgWarning(res.data.desc)
    }
  }).catch(err => {
    hideLoad()
  })
}

/**
 * 获取美团门店的logo数据
 */
function getMTStoreLogo({ storeIDs, vendorOrgCode }, fn) {
  $ajax.get(`v2/store/BatchGetMTStoreLogos?vendorOrgCode=${'' + vendorOrgCode}&storeIDs=${storeIDs}`).then(res => {
    hideLoad()
    if (res.data.code === '0') {
      fn && fn(res.data)
    } else {
      msgWarning(res.data.desc)
    }
  }).catch(err => {
    hideLoad()
  })
}

/**
 * @Title 增加以及获取门店自定义回复模板
 * @Description 增加以及获取门店自定义回复模板
 * @Param	token			header		string	true	"认证token"
 * 
 * @Param	appID         query   	string	true	"美团门店账号"
 * @Param	vendorStoreID   query   	string	true	"美团门店id"
 */
function getMTStoreAutoText(params, fn) {
  $ajax.get(`v2/im/GetCustomReply?appID=${params.appID}&vendorStoreID=${params.vendorStoreID}`).then((res) => {
    hideLoad()
    if (res.data.code === '0') {
      fn && fn(res.data)
    } else {
      msgWarning(res.data.desc)
    }
  }).catch(err => {
    hideLoad()
  })
}

/**
 * @Title 增加门店自定义回复模板
 * @Description 增加门店自定义回复模板
 *  @Param	token			header		string	true	"认证token"
 * 
 *  @Param	appID           formData   	string	true	"京西门店id"
 *  @Param	vendorStoreID   formData   	string	true	"美团门店id"
 *  @Param	replyTemplate   formData   	string	true	"新增或修改自定义模板"
 */
function setMTStoreAutoText(params) {
  let formData = new FormData()
  formData.append('appID', params.appID)
  formData.append('vendorStoreID', params.vendorStoreID)
  formData.append('replyTemplate', params.replyTemplate)
  $ajax.post('v2/im/AddCustomReply', formData, {
  }).then(res => {
    hideLoad()
    if (res.data.code === '0') {
      fn && fn(res.data)
    } else {
      msgWarning(res.data.desc)
    }
  }).catch(err => {
    hideLoad()
  })
}


// 修改淘鲜达线上数据
/**
 * @param {String} vendorOrgCode 平台账号
 * @param {Object} txdStores
 * @param {[]int} txdStores.flag  更新字段标识 1-营业状态 2-营业时间 3-营业范围
 * @param {string} txdStores.txdStoreID 淘鲜达平台id
 * @param {int64} txdStores.status 营业状态
 * @param {string} txdStores.startTime 营业开始时间(HH:mm)
 * @param {string} txdStores.endTime 营业结束时间(HH:mm)
 * @param {string} txdStores.points 营业范围坐标
 */

function taoUpdateStatusOrTimeOrPoints(vendorOrgCode, json, fn) {
  // let formData = new FormData()
  // // formData.append('vendorOrgCode', '34402634')
  // formData.append('vendorOrgCode', vendorOrgCode)
  // formData.append('txdStores', JSON.stringify(json))
  // $ajax.post('v2/store/UpdateTxdStore', formData, {
  // }).then((res) => {
  //   if (res.data.code === '0') {
  //     fn && fn(res.data)
  //   } else {
  //     msgWarning('淘鲜达平台修改失败：' + res.data.desc)
  //   }
  // }).catch((err) => {
  //   msgWarning(err)
  //   hideLoad()
  // })

}

/**
 * 查询美团门店logo审核状态
 * @Param	appPoiCodes	   query		string	true	"门店ID列表，"15478260,18830667" "
 * @Param	vendorOrgCode	 query		string	true	"appID"
 */
function getMtLogoCheckStatus(appPoiCodes, vendorOrgCode, fn) {
  let str = 'appPoiCodes=' + appPoiCodes + '&vendorOrgCode=' + vendorOrgCode
  $ajax.get(`v2/store/GetMtAuditList?${str}`).then(res => {
    // console.log(str, '获取美团信息的数据', res)
    hideLoad()
    if (res.data.code === '0') {
      fn && fn(res.data)
    } else {
      msgWarning(res.data.desc)
    }
  }).catch(err => {
    hideLoad()
  })
}
 
// 超市签约列表api
/**
 * 192.168.56.1:8080/v2/bind/CreateSupermarketSign [post]
 * @description 根据文档创建签约超市列表
 * @param signObj   formData  string     true   "model.SupermarketSign"
 * @param token     header    string     false  "认证token"
 * 
 * SupermarketSign {
 *    StoreID       string      // 门店ID
 *    StoreName     string      // 门店名称
 *    CodeName      string      // 门店所属城市
 *    StoreType     string      // 门店类型
 *    SalesVolume   int64       // 销量
 *    Points        float64     // 扣点
 *    ContractFee   float64     // 签约收费
 *    SignStartTime time.Time   // 签约开始时间
 *    SignEndTime   time.Time   // 签约结束时间
 *    SignPeople    string      // 签约人
 *    Status        string      // 签约状态
 *    Remake        string      // 备注
 *    Reward        string      // 奖励信息
 *    CreateCrowd   string      // 群状态
 * }
 */
async function createSupermarketSign(signObj,noLoading=false) {
  try {
    let res = await api('v2/bind/CreateSupermarketSign', {
      method: 'POST',
      data: signObj,
      noLoading
    })
    return res
  } catch (e) {
    console.error('createSupermarketSign', e)
    throw e
  }
}

/**
 *  192.168.56.1:8080/v2/bind/GetSupermarketSign [post]
 *  @description 查询签约门店数据
 *  
 *  @Param storeID    formData  string  false   "美团门店ID"
 *  @Param storeName  formData  string  false   "美团门店名称"
 *  @Param startTime  formData  int64   false   "签约开始时间"
 *  @Param endTime    formData  int64   false   "签约结束时间"
 *  @Param cityName   formData  string  false   "门店城市"
 *  @Param storeType  formData  string  false   "门店类型"
 *  @Param signPeople formData  string  false   "签约人"
 *  @Param page       formData  int64   true    "页码"
 *  @Param size       formData  int64   true    "页数"
 *  @Param token      header    string  false   "认证token"
 */
async function getSupermarketSign(json) {
  try {
    let res = await api('v2/bind/GetSupermarketSign', {
      method: 'POST',
      // params: json,
      data:json
    })
    return res
  } catch (e) {
    console.error('getSupermarketSign', e)
    throw e
  }
}

/**
 * 192.168.56.1:8080/v2/bind/DownSupermarketSign [post]
 *  @description 下载签约门店数据
 * 
 *  @Param storeID  formData string false "美团门店ID"
 *  @Param storeName  formData string false "美团门店名称"
 *  @Param startTime  formData int64 false "签约开始时间"
 *  @Param endTime  formData int64 false "签约结束时间"
 *  @Param cityName  formData string false "门店城市"
 *  @Param storeType  formData string false "门店类型"
 *  @Param signPeople  formData string false "签约人"
 *  @Param token header string     true "认证token"
 */
async function downSupermarketSign(obj) {
  try {
    let res = await api('v2/bind/DownSupermarketSign', {
      method: 'POST',
      data: obj
    })
    return res
  } catch (e) {
    console.error('downSupermarketSign', e)
    throw e
  }
}

/**
 * 删除签约门店
 */
async function deleteSignStore(storeID,noLoading = false) {
  try {
    let res = await api('v2/bind/DeleteSignData', {
      method: 'DELETE',
      params: {
        storeID
      },
      noLoading
    })
    return res
  } catch (e) {
    console.error('deleteSignStore', e)
    throw e
  }
}

/**
 * 查询门店IM单聊开关状态
 */
async function getStoreImStatus(params,noLoading = false){
  try {
    let res = await api(`v2/im/GetPoiIMStatus?data=${JSON.stringify(params)}`, {
      method:'GET',
      noLoading
    })
    return res
  } catch (e) {
    console.error('downSupermarketSign', e)
    throw e
  }
}

/**
 * 获取消息用户列表
 */
async function getChatUserList(params,noLoading = false) {
  try {
    let res = await api(`v2/im/GetIMUserList?payLoad=${JSON.stringify(params)}`, {
      method:'GET',
      noLoading
    })
    return res
  } catch (e) {
    console.error('getChatUserList', e)
    throw e
  }
}

/**
 * 获取聊天详情
 */
async function getChatDetail(params,noLoading = false) {
  try {
    let res = await api(`v2/im/GetImChatDetail?payLoad=${JSON.stringify(params)}`, {
      method:'GET',
      noLoading
    })
    return res
  } catch (e) {
    console.error('getChatDetail', e)
    throw e
  }
}

/**
 * 解析饿了么消息中的mediaID
 */
async function getUrlByMediaID(params,noLoading = false) {
  try {
    let res = await api(`v2/im/GetElmMedia?data=${JSON.stringify(params)}`, {
      method:'GET',
      noLoading
    })
    return res
  } catch (e) {
    console.error('getUrlByMediaID', e)
    throw e
  }
}

/**
 * 设置已读
 */
async function setImMsgRead(data,noLoading = false) {
  try {
    let res = await api(`v2/im/SetImMsgRead`, {
      method:'POST',
      data,
      noLoading
    })
    return res
  } catch (e) {
    console.error('setImMsgRead', e)
    throw e
  }
}

/**
 * 发送消息
 */
async function sendToVendorV2(data,noLoading = false) {
  try {
    let res = await api(`v2/im/SendToVendorV2`, {
      method:'POST',
      data,
      noLoading
    })
    return res
  } catch (e) {
    console.error('sendToVendorV2', e)
    throw e
  }
}

/**
 * 设置门店的IM状态
 */
async function setPoiIMStatus(data,noLoading = false) {
  try {
    let res = await api(`v2/im/SetPoiIMStatus`, {
      method:'POST',
      data,
      noLoading
    })
    return res
  } catch (e) {
    console.error('setPoiIMStatus', e)
    throw e
  }
}

/**
 * 获取个人门店信息
 */
async function getMyStoreInfo(version= '1.3.5',noLoading = false) {
  try {
    let res = await api(`v2/user2/GetMyStoreList?version=${version}`,{
      method:'GET',
      noLoading
    })
    return res
  } catch (e) {
    throw e
  }
}


/**
 * 饿了么 https://open-retail.ele.me/#/apidoc/me.ele.retail:invoice.settings.batchUpdate-3?aopApiCategory=invoice_manage&type=api_menu
 * @Title 查询门店发票设置
 * @Description 查询门店发票设置
 * @Param	token			header		string	true	"认证token"
 * 
 * @Param	vendorId			      formData		string	true	"平台ID"
 * @Param	vendorStoreID		    formData		string	true	"平台门店ID"
 */
async function queryInvoiceSetting (json) {
  try {
    const res = await api('v2/order/QueryInvoiceSetting', {
      params: {
        ...json
      },
      noLoading: true
    })
    return res
  } catch (e) {
    console.error(e)
    throw e
  }
}


/**
 * @Title 批量更新门店发票设置
 * @Description 批量更新门店发票设置
 * @Param	token			      header		  string	true	"认证token"
 * @Param	vendorId			  formData		string	true	"平台ID"
 * @Param	vendorStoreID		formData		string	true	"平台门店ID"
 * @Param	payload			    formData		string	true	"json数据,格式为 ebaiapi.StoreInvoiceSetting"
 * 
 * type StoreInvoiceSetting struct {
	InvoiceMaterial string `json:"invoice_material"` // PAPER 枚举： PAPER("纸质"), ELECTRONIC("电子");
	InvoiceClass    string `json:"invoice_class"`    // VAT_COMMON 枚举： VAT_COMMON("普通发票"), VAT_SPECIAL("专用发票"), QUOTA("定额发票")
	InvoiceContact  struct {
		Person string `json:"person"` // 联系人
		Phone  string `json:"phone"`  // 电话
	} `json:"invoice_contact"`
	InvoiceMode string `json:"invoice_mode"` // 开具方式 SYS_MANUAL 枚举：SYS_MANUAL("人工开具"), OPEN_API("开放平台"), FLASH_INVOICE("闪电开票"), CODE_INVOICE("扫码开票"), H5_REDIRECT("H5植入"),OTHER("其他形式");
}

 */
async function bathUpdateInvoiceSetting(data) {
  try {
    const res = await api('v2/order/BathUpdateInvoiceSetting', {
      method:'POST',
      data,
      noLoading: true
    })
    return res
  } catch (e) {
    console.error(e)
    throw e
  }
}


/**
 *  @Title 查询门店开票申请 饿百
 *  @Description 批量更新店铺开票申请
 *  @Param	token			      header		  string	true	"认证token"
 *  @Param	vendorId			  formData		string	true	"平台ID"
 *  @Param	vendorStoreID		formData		string	true	"平台门店ID"
 *  @Param	storeID			    formData		int	    true	"京西门店ID"
 * 
 */
async function queryUnansweredInvoice  (json)  {
  try {
    const res = await api('v2/order/QueryUnansweredInvoice', {
      params: {
        ...json
      },
      noLoading: true
    })
    return res
  } catch (e) {
    console.error(e)
    throw e
  }
}


/**
 * 查询门店之间的比值
 * /v2/order/StoreOrderRank
 * @Param	token			  header	string	true	"认证token"
 * @Param	start			  query	  string	true	"起始时间"
 * @Param	end				  query	  string	true	"结束时间"
 * @Param	storeID			query	  string	false	"门店id,[1,2,3]"
 * @Param	rank			  query	  string	true	"排序方式,订单中粮,[DESC,ASC]"
 * @Param	offset			query	  int		  false	"门店列表起始序号（以0开始，缺省为0）"
 * @Param	pageSize		query	  int		  false	"门店列表页大小（缺省为50，-1表示全部）"
 */
async function storeOrderRank(json) {
   try {
    const res = await api('v2/order/StoreOrderRank', {
      params: {
        ...json
      },
      noLoading: true
    })
    return res
  } catch (e) {
    console.error(e)
    throw e
  }
}


/**
 * @description 京西打印机列表
 * @Param	token			  header		string	true	"认证token"
 * @Param	printNo			formData	string	false	"打印机编号"
 * @Param	printKey		formData	string	false	"打印机秘钥"
 * @Param	status			formData	int		  false	"激活状态[-1关机/0未连接/1开机]"
 * @Param	isOnline		formData	int		  false	"在线装填[-1掉线/0未连接/1链接]"
 * @Param	page			  formData	int		  true	"跳过数据条数"
 * @Param	size			  formData	int		  true	"每页展示条数"
 */
async function jxPrinterList(json) {
  try {
    const res = await api('v2/order/QueryJxPrintList', {
      params: {
        ...json
      },
      noLoading: true
    })
    return res
  } catch (e) {
    console.error(e)
    throw e
  }
}

/**
 * 统计门店订单结算以及京西收益,与美团订单对比
 * @Param	token			  header	string	true	"认证token"
 * @Param	storeIDs		query	  string	false	"京西门店ID列表[1,2,3]，缺省不限制"
 * @Param	vendorIds		query	  string	false	"京西门店ID列表[1,2,3]，缺省不限制"
 * @Param	start			  query	  string	true	"起始时间1970-01-01 00:00:00"
 * @Param	end				  query	  string	true	"结束时间1970-01-01 23:59:59"
 * @Param	size			  query	  int		  true	"每页最大数"
 * @Param	offset			query	  int		  true	"跳过数量"
 * @Param ranke       query   string  true  "排序"
 */
export const getStoreSettlementInfo = async(params,noLoading = true) => {
  try {
    let res = await api('v2/store/GetStoreSettlementInfo', {
      params,
      noLoading
    })
   return res
  } catch (error) {
    throw error
  }
}


/**
 * 根据城市code统计京西收益
 * @Param	token			 header	string	true	"认证token"
 * @Param	cityCode	 query	string	false	"京西门店城市列表["1","2","3"]，缺省不限制"
 * @Param	vendorIds	 query	string	false	"京西门店ID列表[1,2,3]，缺省不限制"
 * @Param	start			 query	string	true	"起始时间1970-01-01 00:00:00"
 * @Param	end				 query	string	true	"结束时间1970-01-01 23:59:59"
 * @Param	size			 query	int		  true	"每页最大数"
 * @Param	offset		 query	int		  true	"跳过数量
 * @Param ranke       query   string  true  "排序""  例如：order_count,desc"
 */
export const getCitySettlementInfo = async (params,noLoading = true) => {
  try {
    let res = await api('v2/store/GetCitySettlementInfo', {
      params,
      noLoading
    })
   return res
  } catch (error) {
    throw error
  }
}


/**
 * @Title 查询远程平台可以金额
 * @Description 查询远程平台可以金额
 * @Param	token			  header		string	true	"认证token"
 * @Param	vendorID		query		  int		  true	"门店所属的厂商ID"
 */
export const queryPlatformBalance = async (params,noLoading = true) => {
  try {
    let res = await api('v2/store/QueryPlatformBalance', {
      params,
      noLoading
    })
   return res
  } catch (error) {
    throw error
  }
}


/**
 * @Title 远程平台充值
 * @Description 远程平台充值
 * @Param	token			  header		string	true	"认证token"
 * @Param	vendorID		query		  int		  true	"门店所属的厂商ID"
 * @Param	amount			query		  int		  true	"充值金额分"
 * @Param	category		query		  string	true	"链接场景[PC,H5]"
 * @Param	notifyUrl		query		  string	false	"成功跳转链接(支付宝有,微信没有)"
 */
export const balanceRecharge = async (data,noLoading = true) => {
  try {
    let res = await api('v2/store/BalanceRecharge', {
      method:'POST',
      data,
      noLoading
    })
   return res
  } catch (error) {
    throw error
  }
}

export { 
  setMTStoreAutoText, 
  getMTStoreAutoText, 
  getMTStoreLogo, 
  updateStore, 
  taoUpdateStatusOrTimeOrPoints, 
  getMtLogoCheckStatus, 
  updateVendorStoreStatus, 
  GetVendorStore, 
  createStore, 
  addStoreVendorMap, 
  deleteStoreVendorMap, 
  getStoreVendorMaps, 
  getStoreVendorMap, 
  updateStoreVendorMap, 
  exportMTOrder, 
  getStoreCourierMaps, 
  addStoreCourierMap, 
  updateStoreCourierMap, 
  deleteStoreCourierMap, 
  deleteStoreApi, 
  createVendorStore, 
  syncStoresQualify,
  createSupermarketSign,
  getSupermarketSign,
  downSupermarketSign,
  deleteSignStore,
  getStoreImStatus,
  getChatUserList,
  getChatDetail,
  getUrlByMediaID,
  setImMsgRead,
  sendToVendorV2,
  setPoiIMStatus,
  getMyStoreInfo,
  queryInvoiceSetting,
  bathUpdateInvoiceSetting,
  queryUnansweredInvoice,
  storeOrderRank,
  jxPrinterList
 }



// WEBPACK FOOTER //
// ./src/apis/store.js